<script setup lang="ts">
import RadioButton from 'primevue/radiobutton';
import { useAppConfigStore } from '../stores/app-config-store';
import { useI18n } from 'vue-i18n';

const configStore = useAppConfigStore();

const { t } = useI18n();
</script>

<template>
    <div class="flex app-layout-input-style-select">
        <div class="field-radiobutton flex-1">
            <RadioButton
                v-model="configStore.inputStyle"
                name="input-style"
                value="outlined"
                input-id="input-style-outlined"
            />
            <label for="input-style-outlined">{{
                t('inputStyles.outlined')
            }}</label>
        </div>
        <div class="field-radiobutton flex-1">
            <RadioButton
                v-model="configStore.inputStyle"
                name="input-style"
                value="filled"
                input-id="input-style-filled"
            />
            <label for="input-style-filled">{{
                t('inputStyles.filled')
            }}</label>
        </div>
    </div>
</template>

<i18n lang="json">
{
    "en": {
        "inputStyles": {
            "outlined": "Outlined",
            "filled": "Filled"
        }
    },
    "nl": {
        "inputStyles": {
            "outlined": "Omlijnt",
            "filled": "Gevuld"
        }
    },
    "fr": {
        "inputStyles": {
            "outlined": "Contours",
            "filled": "Remplie"
        }
    }
}
</i18n>
